import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { parseToArray } from '../libs/Util';

const Manuals = (props) => {
    const navigate = useNavigate();
    const [viewHistory, setViewHistory] = useState([]);
    const [listGroup, setListGroup] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const maxVisibleItems = 6; // 한 번에 표시할 box 수

    const formatUpdateDate = (updateDateTime) => {
        if (!updateDateTime) return;
        const now = new Date();
        const updateDate = new Date(updateDateTime);
        const diffInSeconds = Math.floor((now - updateDate) / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);
        const diffInWeeks = Math.floor(diffInDays / 7);
        const diffInMonths = now.getMonth() - updateDate.getMonth() + 12 * (now.getFullYear() - updateDate.getFullYear());

        if (diffInSeconds < 60) {
            return `${diffInSeconds}초 전`;
        } else if (diffInMinutes < 60) {
            return `${diffInMinutes}분 전`;
        } else if (diffInHours < 24) {
            return `${diffInHours}시간 전`;
        } else if (diffInDays < 7) {
            return `${diffInDays}일 전`;
        } else if (diffInWeeks < 4) {
            return `${diffInWeeks}주 전`;
        } else if (diffInMonths < 2) {
            return `${diffInMonths}달 전`;
        } else {
            return updateDate.toISOString().split('T')[0];
        }
    }
    useEffect(() => {
        let storedData = JSON.parse(localStorage.getItem("manualHistory")) || [];
        // 최근 본 순서로 확인하기 위해 reverse 사용
        storedData = [...storedData].reverse();
        setViewHistory(storedData);
    }, []);

    useEffect(() => {
        setManualList();
    }, [viewHistory]);
    const setManualList = () => {
        if (viewHistory.length > 0) {
            const array = [];
            for (let i = 0; i < viewHistory.length; i += maxVisibleItems) {
                array.push(viewHistory.slice(i, i + maxVisibleItems))
            }
            setListGroup(array);
        }
    }

    const handleNext = () => {
        if (currentIndex + 1 < listGroup.length) {
            setCurrentIndex(prev => prev + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
        }
    };

    const containerStyle = {
        width: "100%",
        display: "flex",
        position: "relative",
        overflow: "hidden"
    }

    const animationStyle = {
        minWidth: "100%",
        transform: `translateX(-${currentIndex * 100}%)`,
        transition: "transform 0.5s ease-in-out"
    }

    return (
        <div className="recent">
            <div className="recent-section-title">
                <h2 className="section-title">최근 본 매뉴얼</h2>
            </div>
            <div style={{ position: "relative" }}>
                <div className="recent-wrap-container" style={containerStyle}>
                    {listGroup?.map((group, index) => {
                        return (
                            <ul className='recent-wrap' key={index} style={animationStyle}>
                                {group?.map((x, i) => {
                                    return (
                                        <li key={i} className="recent-box" onClick={() => navigate(x.path)}>
                                            <div className="recent-box-top">
                                                <h4 className="box-cate">{x.category}</h4>
                                                <span className="date">{formatUpdateDate(x.viewDateTime)}</span>
                                            </div>
                                            <h3 className="recent-box-title">{x.module}</h3>
                                            <div className="box-tags">
                                                {parseToArray(x.tag).map((tag, tagIndex) => (
                                                        <span key={tagIndex}>{tag}</span>
                                                    ))}
                                            </div>
                                            {x.fullPath && (
                                                <div className="path" key={index}>
                                                    {(Array.isArray(x.fullPath) ? x.fullPath : x.fullPath.split("/").filter(Boolean)).map((item, index, arr) => (
                                                        <React.Fragment key={index}>
                                                            <span className="path-li">{item}</span>
                                                            {index < arr.length - 1 && <i className="icoKdc12 next"></i>}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        );
                    })}
                </div>
                <Link className={currentIndex === 0 ? 'dis':''} onClick={handlePrev}>
                    <i className="icoKdc40 prev recent-btn-prev"></i>
                </Link>
                <Link className={currentIndex === listGroup.length - 1 ? 'dis' : ''} onClick={handleNext}>
                    <i className="icoKdc40 next recent-btn-next"></i>
                </Link>
            </div>
        </div>
    );
}

export default Manuals;